import React, { useEffect, Fragment, useState } from "react";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import Breadcrumb from "../common/breadcrumb";
// import Datatable from "../common/datatable";
import { User, Box, DollarSign, Layers, Repeat } from "react-feather";
import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  /* Button,
  Label,
  Form,
  FormGroup,*/
} from "reactstrap";
import UserTransactions from "./userTransaction";
import UserBoxTable from "./userBoxTable";
// import TotalBattlesTable from "./totalBattlesTable";
// import Userinventory from "./user-inventory";
import DeleteConfirmPopup from "../common/deleteConfirmPopup";
import { useDispatch, useSelector } from "react-redux";
import { queryString } from "./../../utils/queryString";
import Userinventory from "./user-inventory";
import {
  getloginHistoryData,
  getUserDetailById,
} from "../../reducers/adminReducers";
import placeholder from "../../assets/images/fashion/product/12.jpg";
import { adminInstance } from "../../config/axios";
import { toast } from "react-toastify";
// import LoginHistory from "./loginHistory";
import Loader from "../loader/loader";
import UserExchangeItems from "./user-exchange-items";
import Sellitems from "./sellitems";
import Transactions from "./transactions";
import UpgradeItems from "./upgradeItems";
// import Affiliates from "./affiliates";
// import AffiliatesStats from "./affiliateStatsForUser";
const UserProfileDetails = () => {
  const result = useSelector((state) => state.admin);
  // console.log("All result", result);
  const {
    userData,
    // openBoxCount,
    // pnL,
    userTransactions,
    userBoxList,
    //playBattleList,
    userinventoryList,
    exchangeItemsData,
    sellItemsData,
    detailedTransactionData,
    upgraderList
    // loginHistory,
  } = result || {};
  const dispatch = useDispatch();
  const { id: userId } = queryString();
  const [open, setOpen] = useState(false);
  const [activeId, setActiveId] = useState();
  // const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function getData() {
      setLoading(true);
      await dispatch(getloginHistoryData(userId));
      const res1 = await dispatch(getUserDetailById(userId));
      if (res1) setLoading(false);
    }
    getData();
  }, [dispatch, userId]);
  const handleOnDelete = async (id) => {
    try {
      const response = await adminInstance().delete(
        `api/admin/deleteInventory/${id}/${userId}`
      );
      const { code } = response.data;
      if (code === 200) {
        toast.success("Successfully Deleted");
        dispatch(getUserDetailById(userId));
      }
      setOpen(false);
    } catch (error) {}
  };
  const onCloseModal = () => {
    setOpen(false);
  };
  const refactoredUserExchangeItems = exchangeItemsData?.flatMap(
    (elem) => elem?.exchangePairs || []
  );
  return (
    <Fragment>
      {loading && <Loader />}
      <Breadcrumb title="User Profile Details" parent="Settings" />
      <Container fluid={true}>
        <Row>
          <Col xl="12">
            <Card className="profile-card user__profile__card">
              <CardBody>
                <div>
                  <Tabs>
                    <TabList className="nav nav-tabs tab-coupon">
                      <Tab className="nav-link">
                        <User className="mr-2" />
                        Profile
                      </Tab>
                      <Tab className="nav-link">
                        <DollarSign className="mr-2" />
                        Payment History
                      </Tab>
                      <Tab className="nav-link">
                        <DollarSign className="mr-2" />
                        Transactions
                      </Tab>
                      <Tab className="nav-link">
                        <Box className="mr-2" />
                        Total Box
                      </Tab>
                      <Tab className="nav-link">
                        <Layers className="mr-2" />
                        Cart Items
                      </Tab>

                      <Tab className="nav-link">
                        <Repeat className="mr-2" />
                        Exchange Items
                      </Tab>
                      <Tab className="nav-link">
                        <Box className="mr-2" />
                        Sell Items
                      </Tab>
                      <Tab className="nav-link">
                        <Box className="mr-2" />
                        Upgrade Items
                      </Tab>
                    </TabList>

                    <TabPanel>
                      <section
                        className="section about-section gray-bg"
                        id="about">
                        <div className="container">
                          <div className="row align-items-center flex-row-reverse">
                            <div className="col-lg-8">
                              <div className="about-text go-to">
                                <h3 className="dark-color">User Info</h3>
                                <div className="row about-list">
                                  <div className="col-md-6">
                                    <div className="media">
                                      <label>First Name</label>
                                      <p>{userData?.firstname || ""}</p>
                                    </div>
                                    <div className="media">
                                      <label>Last Name</label>
                                      <p>{userData?.lastname || ""}</p>
                                    </div>
                                    <div className="media">
                                      <label>Email</label>
                                      <p>{userData?.email || ""}</p>
                                    </div>
                                    <div className="media">
                                      <label>Total Depost</label>
                                      <p>{userData?.totalDeposit || ""}</p>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="media">
                                      <label>Username</label>
                                      <p>{userData?.username || ""}</p>
                                    </div>
                                    <div className="media">
                                      <label>Mobile No</label>
                                      <p>{userData?.mobile || ""}</p>
                                    </div>
                                    <div className="media">
                                      <label>Wallet</label>
                                      <p>
                                        {userData?.walletAmount?.toFixed(2) ||
                                          0}
                                      </p>
                                    </div>
                                    <div className="media">
                                      <label>Referal</label>
                                      <p>
                                        {userData?.referalCount?.toFixed(2) ||
                                          0}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="about-avatar">
                                <img
                                  src={userData?.profile || placeholder}
                                  title=""
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </TabPanel>
                    <TabPanel>
                      <div id="batchDelete" className="transactions">
                        <UserTransactions
                          multiSelectOption={false}
                          myData={userTransactions}
                          pageSize={10}
                          pagination={true}
                          className="-striped -highlight"
                        />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div id="batchDelete" className="transactions">
                        <Transactions
                          multiSelectOption={false}
                          myData={detailedTransactionData}
                          pageSize={10}
                          pagination={true}
                          className="-striped -highlight"
                        />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div id="batchDelete" className="transactions">
                        <UserBoxTable
                          multiSelectOption={false}
                          myData={userBoxList}
                          pageSize={10}
                          pagination={true}
                          className="-striped -highlight"
                        />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div id="batchDelete" className="transactions">
                        <Userinventory
                          multiSelectOption={false}
                          myData={userinventoryList}
                          pageSize={10}
                          pagination={true}
                          className="-striped -highlight"
                          setOpen={setOpen}
                          setActiveId={setActiveId}
                          id={userId}
                        />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div id="batchDelete" className="transactions">
                        <UserExchangeItems
                          multiSelectOption={false}
                          myData={refactoredUserExchangeItems}
                          pagination={true}
                          className="-striped -highlight"
                        />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div id="batchDelete" className="transactions">
                        <Sellitems
                          multiSelectOption={false}
                          myData={sellItemsData}
                          pagination={true}
                          className="-striped -highlight"
                        />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div id="batchDelete" className="transactions">
                        <UpgradeItems
                          multiSelectOption={false}
                          myData={upgraderList}
                          pagination={true}
                          className="-striped -highlight"
                        />
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <DeleteConfirmPopup
        title={"Delete User"}
        open={open}
        handleOnDelete={handleOnDelete}
        onCloseModal={onCloseModal}
        id={activeId}
      />
    </Fragment>
  );
};

export default UserProfileDetails;
